<app-header-content-footer [headerTitle]="t('business-settings')" *transloco="let t">
  <app-sidenav-content content>
    <div class="business-settings-page-root" content>
      <div class="business-settings-content" content>
        <app-header header>{{t('edit-data')}}</app-header>
        <app-paragraph>{{t('edit-business-data')}}</app-paragraph>
        <app-expansion-panel id="expand-business-data" section [title]="t('business-data')">
          <div class="expansion-panel-content">
            <app-business-data-form [businessData]="businessData">
            </app-business-data-form>
            <app-label *ngIf="saveDataFeedback.hasFeedback()" [isError]="saveDataFeedback.isError">
              {{ t(saveDataFeedback.feedback) }}
            </app-label>
            <app-primary-button id="edit-data-save-click" [disabled]="isSaveDataDisabled()" (clickAction)="saveData()">
              {{t('save-changes')}}
            </app-primary-button>
          </div>
        </app-expansion-panel>
        <div class="divider"></div>

        <app-paragraph>{{t('edit-business-printers')}}</app-paragraph>
        <app-expansion-panel id="expand-business-equipments" section [title]="t('business-equipments')">
          <div class="expansion-panel-content">
            <app-paragraph class="business-equipment-register-info">
              {{t('business-equipment-register-info')}}
            </app-paragraph>
            <div id="add-new-printer-line" class="add-new-printer-line">
              <app-input
                [id]="'business-equipment-serial-add'"
                [label]="equipmentData.labels.serial"
                [control]="serial"
                required
                class="serial-component"
              ></app-input>
              <app-icon-button
                class="button-component"
                id="add-equipment"
                icon="add_box"
                type="submit"
                (clickAction)="editEquipmentNextClick()"
                [disabled]="pendingProductInsertion"
              >
                {{ equipmentData.labels.addEquipment }}
              </app-icon-button>
            </div>
            <app-label *ngIf="saveEquipmentFeedback.hasFeedback()" [isError]="saveEquipmentFeedback.isError">
              {{ t(saveEquipmentFeedback.feedback) }}
            </app-label>
            <app-label *ngIf="serverError" isError>
              {{equipmentData.labels.invalidSerialErrorMessage}}
            </app-label>
            <app-label *ngIf="equipmentExistsError" isError>
              {{equipmentData.labels.equipmentExistsError}}
            </app-label>
            <div *ngIf="pendingProductRegistration" class="pending-product-registration">
              <app-label class="pending-product-label bold">{{
                  t('this-product-still-needs-registered')
                }}</app-label>
              <app-paragraph>
                {{ t('your-printer-is-not-registered-info') }}
              </app-paragraph>
              <div class="unregistered-equipment">
                <app-header
                >{{
                    t('modelname-register-data', {
                      planModel: newEquipmentFormGroup!.get('planModel')!.getRawValue()
                    })
                  }}
                </app-header>
                <div class="unregistered-equipment-form">
                  <app-input
                    id="place-of-purchase"
                    [label]="t('place-of-purchase')"
                    [control]="registerService.registerEquipmentFormGroup.controls.placeOfPurchase"
                    required
                  ></app-input>
                  <app-input
                    id="installation-date"
                    [datepicker]="installationDate"
                    [label]="t('installation-date')"
                    [control]="registerService.registerEquipmentFormGroup.controls.installationDate"
                    required
                  ></app-input>
                  <mat-datepicker #installationDate></mat-datepicker>
                </div>
              </div>
            </div>
            <app-checkbox *ngIf="pendingProductRegistration"
                          id="register-equipments-agree-checkbox"
                          [formGroup]="registerService.registerEquipmentFormGroup"
                          abstractFormControlName="agree">
              {{t('register-equipment-agree-pre-privacy-policy-info')}}
              <app-anchor target="_blank" [href]="privacyLink">{{t('privacy-policy') | lowercase}}</app-anchor>
              {{t('register-equipment-agree-post-privacy-policy-info')}}
            </app-checkbox>
            <div class="edit-equipment-button-group" *ngIf="pendingProductRegistration">
              <app-primary-button id="edit-equipment-cancel-click"
                                  stroked
                                  [disabled]="equipmentActionLoading"
                                  (clickAction)="editEquipmentCancelClick()"
                                  class="edit-equipment-cancel-button">
                {{t('cancel')}}
              </app-primary-button>
              <app-primary-button id="edit-equipment-next-click"
                                  [disabled]="isSaveEquipmentDisabled()"
                                  (clickAction)="editEquipmentNextClick()"
                                  class="edit-equipment-next-button">
                {{t(editEquipmentNextButtonLabel)}}
              </app-primary-button>
              <div *ngIf="isEquipmentLoading" class="loading">
                <mat-spinner diameter="30"></mat-spinner>
              </div>
            </div>
            <div class="divider"></div>
            <div class="equipment-content"
                 infinite-scroll
                 [infiniteScrollDistance]="0.1"
                 [scrollWindow]="false"
                 [immediateCheck]="true"
                 (scrolled)="updatePageEquipmentData()">
              <app-business-equipment-form [equipmentData]="equipmentData"
                                           [phase]="businessEquipmentFormPhase"
                                           [loading]="equipmentDataLoading"
                                           [(isAddingEquipment)]="isAddingEquipment"
                                           [registerEquipmentFormGroup]="registerService.registerEquipmentFormGroup"
                                           [feedback]="ephemeralFeedback.feedback"
                                           [privacyLink]="privacyLink"
                                           [isRegistration]="false"
                                           [showAddingEquipmentButton]="false"
                                           (deleteEquipmentAction)="deleteEquipment($event)">
              </app-business-equipment-form>
            </div>
          </div>
        </app-expansion-panel>
        <div class="divider"></div>

        <app-paragraph>{{t('manage-business-representatives')}}</app-paragraph>
        <app-expansion-panel id="expand-manage-business-representatives" section [title]="t('manage-representatives')">
          <div class="expansion-panel-content">
            <app-representative-list [generalizedRepresentativeList]="getGeneralizedRepresentativeList()"
              [expiredTip]="t('invitation-expired')" (promote)="openConfirmPromotionDialog($event)"
              (remove)="openConfirmDeleteDialog($event)" (resendInvite)="openConfirmResendInviteDialog($event)"
              [labels]="representativeItemLabels" [canTamper]="!isInviteRepresentativeInputDisabled()" [isLoading]="listLoading">
            </app-representative-list>
            <app-label-prompt-button [formGroup]="manageRepresentatives" abstractControlName="email"
              [inputLabel]="t('email-address')" [buttonLabel]="t('invite-business-representative')"
              [title]="t('invite-a-business-representative')" (submitAction)="inviteBusinessRepresentative()"
              [buttonDisabled]="isInviteRepresentativeButtonDisabled()"
              [inputDisabled]="isInviteRepresentativeInputDisabled()" [errorMsg]="t(inviteErrorFeedback.feedback)">
            </app-label-prompt-button>
          </div>
        </app-expansion-panel>
      </div>
    </div>
  </app-sidenav-content>
</app-header-content-footer>
